import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.scss';

export default class Toggleable extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        type: PropTypes.oneOf(['left', 'right']),
        enabled: PropTypes.bool,
        children: PropTypes.node,
        tag: PropTypes.any,
    };

    static defaultProps = {
        type: 'right',
        enabled: false,
        tag: 'div',
    };

    render() {
        const { tag: Element, children, enabled, type, className, ...rest } = this.props;
        const classes = classNames(styles.root, className, styles[type], {
            [styles.enabled]: enabled,
        });

        return (
            <Element className={classes} {...rest}>
                {children}
            </Element>
        );
    }
}
